<app-filter-card
  i18n-heading
  heading="Auftragsfilter"
  testId="order-filter"
  [canReset]="isFiltered"
  (reset)="resetFilter()"
>
  <app-date-range-filter
    testId="order-date"
    [(from)]="filter.dateFrom"
    [(to)]="filter.dateTo"
    (rangeChange)="searchThis()"
  ></app-date-range-filter>
</app-filter-card>
